import { render } from "./Days.vue?vue&type=template&id=63507bb4"
import script from "./Days.vue?vue&type=script&lang=js"
export * from "./Days.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__